import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup,  ReactiveFormsModule,  Validators } from '@angular/forms';
import { MatModule } from '../appModules/mat.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ExportService } from '../shared/services/exportservice';

@Component({
  selector: 'app-scheme-master',
  imports:  [CommonModule,ReactiveFormsModule,MatModule,MatPaginatorModule],
  templateUrl: './scheme-master.component.html',
  styleUrl: './scheme-master.component.scss'
})
export class SchemeMasterComponent {
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: any = {
   label: ['sno','Scheme_name','createdAt'],
   cols: ['sno','Scheme_name','createdAt']
  }
  pagination = {
    length: 0,
    page: 1,
    limit: 5,
  };
  currentPage=0;
 //currentindex=1;
 formGroup: FormGroup;
 isLoading = false;

 SchemeId: string | null = null;
 
 isSchemeList=false;

 constructor(
   private fb: FormBuilder,
   private api: ApiService,
   private common: CommonService,
   private exportService: ExportService
 ) {
   this.formGroup = this.fb.group({
    Scheme_name: ['', [Validators.required]],
   });
 }

 ngOnInit(): void {
  
   this.getSchemeList();
 }

 getSchemeList_download(): void {
  
  this.api.get(`settings/getSchemeList`).subscribe({
    next: (response) => {
    
      if (response && response.data && response.data.length > 0) {

        this.dataSource = response.data;
        this.pagination.length = response?.totalCount || 0;
        const exportPayload = {
          filename: 'Schema-list',
          displayedColumns: this.displayedColumns.cols,
          data: this.dataSource,
          dateField:['createdAt'],
          isDateMultiply:false
        };
        this.exportService.exportExcel(exportPayload);
      } else {
        console.log('No settings found or empty settings array');
      }
      this.isLoading = false;
    },
    error: (error) => {
      console.error('Error fetching settings information:', error);
      this.common.notification('Error loading settings information', true);
      this.isLoading = false;
    }
  });
}

 getSchemeList(): void {
   this.isSchemeList=true;
   this.isLoading = true;

   const queryParam: any = [];
   queryParam.push(`page=${this.pagination.page}`, `limit=${this.pagination.limit}`);
   this.api.get(`settings/getSchemeList?${queryParam.join('&')}`).subscribe({
     next: (response) => {
     
       if (response && response.data && response.data.length > 0) {

         this.dataSource = response.data;
         this.pagination.length = response?.totalCount || 0;
       } else {
         console.log('No settings found or empty settings array');
       }
       this.isLoading = false;
     },
     error: (error) => {
       console.error('Error fetching settings information:', error);
       this.common.notification('Error loading settings information', true);
       this.isLoading = false;
     }
   });
 }
 
 resetForm(): void {
   this.isSchemeList=false;
   this.formGroup.reset();
  
 }


isEdit=false;
 edit(row:any){
   this.isSchemeList=false;   
   this.SchemeId=row.id;
   this.isEdit=true;
   this.formGroup.patchValue({
    Scheme_name: row.Scheme_name,
   });
 }
   


 saveScheme(): void {
   this.isSchemeList=false;
   if (this.formGroup.invalid) {
    this.common.notification('Please fill all required information', true);
     return;
   }

   this.isLoading = true; 
   let formData =  this.formGroup.value;
   if (this.SchemeId) {
        
     this.api.put(`settings/updateScheme/${this.SchemeId}`, formData).subscribe({
       next: (response) => {
         
         this.common.notification(response.message);
         this.isLoading = false;
       },
       error: (error) => {
         console.error('Error updating settings information. Full error:', error);
         this.isLoading = false;
       }
       
     });
     this.resetForm();
   } else {
    this.api.post(`settings/addScheme`,formData,true).subscribe({
       next: (response) => {
        if (response.status) {
           this.common.notification(response.message);
           this.isLoading = false;
         }else{
         this.common.notification(response.message);
        }
         this.isLoading = false;
       },
       error: (error) => {
         this.common.notification(`Error saving razorpay: ${error.message || 'Unknown error'}`, true);
         this.isLoading = false;
       }
     });
     this.getSchemeList();
     this.resetForm();
   }
 }
 



 addScheme(){
   this.resetForm();
   this.isSchemeList=false;
 }
 


back(){
 this.isEdit=false;
 this.isSchemeList=true;  
 this.resetForm();
 this.SchemeId=null;
 this.getSchemeList();
}

delete(row:any)
{

 const SchemeId=row.id;
 this.api.put(`settings/deleteScheme/${SchemeId}`,'').subscribe((resp:any)=>{
   if(resp.status){
     this.common.notification(resp.message);
   }else{
     this.common.notification("unable to delete");
   }
   this.getSchemeList();

 });
}

pageEvent(e: any) {
  this.isLoading = false;
 
  this.pagination.page = e.pageIndex + 1;
  this.pagination.limit = e.pageSize;
  this.currentPage = e.pageIndex * e.pageSize;
  this.getSchemeList();
}
}
